/**
 * Legacy LoggerApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.loggerApi`) keep resolving.
 *
 * The actual LoggerApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/logger/logger-api.service.ts
 */
angular.module("acme.common.service.loggerApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
